import React from "react";
import "./index.scss";

function Compare() {
  const insurancePlans = [
    {
      id: 1,
      company: "ICICI Lombard",
      price: "₹50,102",
      recommended: false,
      details: ["₹1,200", "₹17,343", "₹303"],
      features: [true, false, true],
    },
    {
      id: 2,
      company: "HDFC ERGO",
      price: "₹40,102",
      recommended: true,
      details: ["₹1,200", "₹18,303", "₹280"],
      features: [true, true, true],
    },
    {
      id: 3,
      company: "Bajaj Allianz",
      price: "₹50,102",
      recommended: false,
      details: ["₹1,200", "₹16,640", "₹340"],
      features: [true, false, true],
    },
  ];

  const addOns = [
    {
      icon: "",
      title: "Property Security",
      amount: "2 Cr",
      description: [
        "Explosion and Implosion",
        "Lightning",
        "Violent Storms (like Cyclone, etc",
      ],
    },
    {
      icon: "",
      title: "Cyber Security",
      amount: "3 L",
      description: [
        "Identity Theft",
        "Unauthorized transaction",
        "Reputational injury",
      ],
    },
    {
      icon: "",
      title: "Personal Accident",
      amount: "50 L",
      description: [
        "Identity Theft",
        "Unauthorized transaction",
        "Reputational injury",
      ],
    },
  ];

  return (
    <div className="comparison-container">
      {/* <div className="side-panel">
        <h3>Property Security</h3>
        <ul>
          <li>Explosion and Implosion</li>
          <li>Lightning</li>
          <li>Violent Storms</li>
        </ul>
        <h3>Cyber Security</h3>
        <ul>
          <li>Identity Theft</li>
          <li>Unauthorized Transactions</li>
          <li>Reputational Injury</li>
        </ul>
        <h3>Personal Accident</h3>
        <ul>
          <li>Identity Theft</li>
          <li>Unauthorized Transactions</li>
          <li>Reputational Injury</li>
        </ul>
      </div>

      <div className="plans-container">
        {insurancePlans.map((plan) => (
          <div
            key={plan.id}
            className={`plan-card ${plan.recommended ? "recommended" : ""}`}
          >
            {plan.recommended && <div className="badge">Recommended</div>}
            <div className="">
              <h4>{plan.company}</h4>
            </div>
            <p className="price">{plan.price}</p>
            <button className="buy-button">Buy Now</button>
            <div className="rate-comparison-container">
              {plan.details.map((detail, index) => (
                <div key={index} className="feature">
                  <span>{detail}</span>
                  <span className={plan.features[index] ? "check" : "cross"}>
                    {plan.features[index] ? "✔️" : "❌"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div> */}
      <div className="left-container">
        {addOns.map((addon) => (
          <div className="addons-container">
            <div className="upper-container">
              <div>
                <span>{addon.icon}</span>
                <span>{addon.title}</span>
              </div>
              <div>
                <span>{addon.amount}</span>
              </div>
            </div>
            <div className="bene-list-container">
              <div>{addon.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Compare;
